// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 560 ? "45d1160f" : chunkId) + "." + {"97":"c3ae7b652f1f088c","139":"e0b8da9815ba2cf2","560":"2df1c1d51152b0cc","988":"e52cfdee94f1747f"}[chunkId] + ".js";
};